import { MANUAL_PAYMENT_METHOD_TYPES, PAYMENT_METHOD_DEFAULT,PAYMENT_METHOD_LABELS } from "./paymentMethodCodes";
import { trStatic } from "../i18n/static";

/** Minimal fields from `/api/v1/payment-method-definitions` for active tenant-managed payment methods. */
export type PaymentMethodDefinitionLike = {
  paymentMethodType: number;
  name: string;
  isActive?: boolean;
};

/**
 * Select options: only payment methods with an active tenant definition, sorted by name.
 */
export function paymentMethodDefinitionSelectOptions(
  defs: PaymentMethodDefinitionLike[] | null | undefined,
  manualOnly = false
): Array<{ value: number; label: string }> {
  return (defs || []).filter((x) => PAYMENT_METHOD_LABELS[x.paymentMethodType] && x.isActive !== false
    && (!manualOnly || MANUAL_PAYMENT_METHOD_TYPES.includes(x.paymentMethodType))).map((m) => ({
    value: Number(m.paymentMethodType),
    label: paymentMethodLabel(m.paymentMethodType),
  })).sort((a, b) => a.label.localeCompare(b.label));
}

export function paymentMethodLabel(method?: string | number | null, _custom?: Record<number | string, string>): string {
  if (method == null) return "–";
  const num = typeof method === "number" ? method : Number(String(method).trim());
  if (!Number.isFinite(num)) return "–";

  if (PAYMENT_METHOD_LABELS[num]) return trStatic(PAYMENT_METHOD_LABELS[num]);
  return String(num);
}

export function paymentMethodEnumOptions(_custom?: Record<number, string>) {
  return Object.entries(PAYMENT_METHOD_LABELS).map(([value, label]) => ({
    value: Number(value),
    label: trStatic(label),
  }));
}

export const paymentMethodOptions = paymentMethodEnumOptions();

export function resolvePaymentMethod(value?: number | null): number {
  if (value == null || !Number.isFinite(value)) return PAYMENT_METHOD_DEFAULT;
  return PAYMENT_METHOD_LABELS[value] ? value : PAYMENT_METHOD_DEFAULT;
}
